// src/components/EventDetailsModalTW.jsx
import React from "react";

export default function EventDetailsModalTW({ open, onClose, event }) {
  if (!open) return null;

  const link = event?.registration_link || event?.link;

  return (
    <div className="tw-fixed tw-inset-0 tw-z-[9999] tw-flex tw-items-center tw-justify-center tw-p-4">
      {/* backdrop */}
      <button
        type="button"
        className="tw-absolute tw-inset-0 tw-bg-black/50"
        onClick={onClose}
        aria-label="Bezárás"
      />

      {/* panel */}
      <div className="tw-relative tw-z-10 tw-w-full tw-max-w-2xl tw-rounded-2xl tw-bg-white tw-p-6 tw-shadow-xl">
        <div className="tw-flex tw-items-start tw-justify-between tw-gap-4">
          <h2 className="tw-text-xl tw-font-semibold">
            {event?.title ?? "Részletek"}
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="tw-rounded-md tw-px-2 tw-py-1 tw-text-sm hover:tw-bg-black/5"
          >
            ✕
          </button>
        </div>

        <div className="tw-mt-4 tw-space-y-2 tw-text-sm tw-text-slate-700">
          {event?.start_date && (
            <div>
              <span className="tw-font-medium">Kezdés:</span> {event.start_date}
            </div>
          )}
          {event?.end_date && (
            <div>
              <span className="tw-font-medium">Vége:</span> {event.end_date}
            </div>
          )}
          {event?.location && (
            <div>
              <span className="tw-font-medium">Helyszín:</span> {event.location}
            </div>
          )}
          {event?.description && (
            <div className="tw-whitespace-pre-line">{event.description}</div>
          )}
        </div>

        {link && (
          <a
            className="tw-mt-6 tw-inline-flex tw-items-center tw-rounded-xl tw-bg-blue-600 tw-px-4 tw-py-2 tw-text-white hover:tw-bg-blue-700 tw-no-underline"
            href={link}
            target="_blank"
            rel="noreferrer"
          >
            Jelentkezés / infó
          </a>
        )}
      </div>
    </div>
  );
}

